module.exports = __webpack_public_path__ + "ptc_momoro_U1.b780350f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_U1.jpg
// module id = 50P6
// module chunks = 0